
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="border-t py-6 px-4 bg-background">
      <div className="container max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center">
        <p className="text-muted-foreground text-sm">
          © {new Date().getFullYear()} Accesstopia. All rights reserved.
        </p>
        <div className="flex items-center gap-6 mt-4 md:mt-0">
          <div className="flex gap-4"> {/* Reduced gap from 6 to 4 */}
            <Link to="/" className="text-muted-foreground hover:text-foreground text-sm">
              Home
            </Link>
            <Link to="/pricing" className="text-muted-foreground hover:text-foreground text-sm">
              Pricing
            </Link>
            <Link to="/installation" className="text-muted-foreground hover:text-foreground text-sm">
              Installation
            </Link>
            <Link to="/demo" className="text-muted-foreground hover:text-foreground text-sm">
              Demo
            </Link>
          </div>
          <a 
            href="https://www.mattblak.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-xs text-muted-foreground hover:text-foreground ml-4"
          >
            Powered by Matt Blak
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
